import axios from "axios";

var instance = axios.create({
    validateStatus: function (status) {
        return status == 200;
    }
});

export async function getPendingFiles() {
    return await instance.get(`/files/pending`)
        .then(response => {
            return response.data;
        });
}

export async function importImage(filepath) {
    return await instance.post(`/import/${filepath}`)
        .then(response => {
            return response.data;
        });
}

export async function deleteImage(id) {
    return await instance.delete(`/images/${id}`)
        .then(response => {
            return response.data;
        });
}

export async function getAIList() {
    return await instance.get(`/ai`)
        .then(response => {
            return response.data;
        });
}

export async function runAITask(image_id, wsi, ontology, ai_id, roi_term_ids = [], roi_ids = []) {
    return await instance.post(`/ai/tasks`, {
        roi_term_ids,
        roi_ids,
    }, {
        params: {
            image_id,
            wsi,
            ontology,
            ai_id,
        }
    })
        .then(response => {
            return response.data;
        });
}

// Blood Film Analysis API functions
export async function runBloodFilmAnalysis(analysisParams) {
    return await instance.post(`/blood-film-analysis`, analysisParams)
        .then(response => {
            return response.data;
        });
}

export async function getBloodFilmAnalysisStatus(taskId) {
    return await instance.get(`/blood-film-analysis/${taskId}/status`)
        .then(response => {
            return response.data;
        });
}

export async function getBloodFilmAnalysisResults(taskId) {
    return await instance.get(`/blood-film-analysis/${taskId}/results`)
        .then(response => {
            return response.data;
        });
}

export async function getBloodFilmAnalysisReport(taskId) {
    return await instance.get(`/blood-film-analysis/${taskId}/report`)
        .then(response => {
            return response.data.downloadUrl;
        });
}

export async function getBloodFilmAnalysisHistory(imageId) {
    return await instance.get(`/blood-film-analysis/history/${imageId}`)
        .then(response => {
            return response.data;
        });
}

// Prostate Gleason Analysis API functions
export async function runProstateGleasonAnalysis(analysisParams) {
    return await instance.post(`/prostate-gleason-analysis`, analysisParams)
        .then(response => {
            return response.data;
        });
}

export async function getProstateGleasonAnalysisStatus(taskId) {
    return await instance.get(`/prostate-gleason-analysis/${taskId}/status`)
        .then(response => {
            return response.data;
        });
}

export async function getProstateGleasonAnalysisResults(taskId) {
    return await instance.get(`/prostate-gleason-analysis/${taskId}/results`)
        .then(response => {
            return response.data;
        });
}

export async function getProstateGleasonAnalysisReport(taskId) {
    return await instance.get(`/prostate-gleason-analysis/${taskId}/report`)
        .then(response => {
            return response.data.downloadUrl;
        });
}

export async function getProstateGleasonAnalysisHistory(imageId) {
    return await instance.get(`/prostate-gleason-analysis/history/${imageId}`)
        .then(response => {
            return response.data;
        });
}

const ViewerClient = {
    getPendingFiles,
    importImage,
    deleteImage,
    getAIList,
    runAITask,
    runBloodFilmAnalysis,
    getBloodFilmAnalysisStatus,
    getBloodFilmAnalysisResults,
    getBloodFilmAnalysisReport,
    getBloodFilmAnalysisHistory,
    runProstateGleasonAnalysis,
    getProstateGleasonAnalysisStatus,
    getProstateGleasonAnalysisResults,
    getProstateGleasonAnalysisReport,
    getProstateGleasonAnalysisHistory,
}

export default ViewerClient;
